import React, {useEffect, useState} from 'react';
import {Construction, Edit, Home, Mail, Newspaper, Plus, Reply, Trash2, UserPlus, Users, X} from 'lucide-react';
import {UUID} from "node:crypto"
import {News, NewsCategory} from "../../../Utills/RestApiModels/NewsModel";
import {Message, MessageType} from "../../../Utills/RestApiModels/MessageModel";
import {ApiController} from "../../../Utills/ApiController";
import {generateUUID} from "three/src/math/MathUtils";
import Particles from "./Particle";

// Komponenty Particles pozostają bez zmian


const AdminPanelComponent: React.FunctionComponent = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [activeSection, setActiveSection] = useState('dashboard');
    const [showNewsModal, setShowNewsModal] = useState(false);
    const [showUserModal, setShowUserModal] = useState(false);

    // newsData początkowo puste, używamy zaimportowanego typu News
    const [newsData, setNewsData] = useState<News[]>([]);
    // editingNews używa zaimportowanego typu News
    const [editingNews, setEditingNews] = useState<News | null>(null);

    // Dodajemy stan ładowania newsów
    const [loadingNews, setLoadingNews] = useState(false);

    // Usuwamy mockowe dane, inicjalizujemy pustą tablicą
    const [messagesData, setMessagesData] = useState<Message[]>([]);


    const [loginForm, setLoginForm] = useState({ username: '', password: '' });

    const handleLogin = () => {
        if (loginForm.username === 'admin' && loginForm.password === 'admin') {
            setIsLoggedIn(true);
        } else {
            alert('Nieprawidłowe dane logowania. Użyj: admin/admin');
        }
    };

    const handleLogout = () => {
        setIsLoggedIn(false);
        setActiveSection('dashboard');
        // Opcjonalnie: wyczyść dane newsów po wylogowaniu
        setNewsData([]);
    };

    // Użycie useEffect do pobrania danych po zalogowaniu
    useEffect(() => {
        let controller = new ApiController();
        if (isLoggedIn) {
            setLoadingNews(true);
            // Pobieranie newsów
            controller.GetNewses().then(newses => {
                if ((newses as any).error) {
                    setNewsData([{id: "error" as UUID, title: "Loading data error", category: NewsCategory.EVENT, description: "", content: "", modificationDate: new Date()}]);
                } else {
                    const sortedData = Array.isArray(newses)
                        ? newses.sort((a, b) =>
                            new Date(b.modificationDate).getTime() - new Date(a.modificationDate).getTime())
                        : [];
                    setNewsData(sortedData);
                }
                setLoadingNews(false);
            }).catch(() => {
                setNewsData([{id: "error" as UUID, title: "Loading data error", category: NewsCategory.EVENT, description: "", content: "", modificationDate: new Date()}]);
                setLoadingNews(false);
            });

            // Pobieranie wiadomości
            controller.GetMessages().then(msgs => {
                if ((msgs as any).error) {
                    setMessagesData([{
                        id: "error",
                        fullname: "Loading data error",
                        email: "",
                        topic: MessageType.QUESTION,
                        content: ""
                    }]);
                } else {
                    setMessagesData(Array.isArray(msgs) ? msgs : []);
                }
            }).catch(() => {
                setMessagesData([{
                    id: "error",
                    fullname: "Loading data error",
                    email: "",
                    topic: MessageType.QUESTION,
                    content: ""
                }]);
            });
        }
    }, [isLoggedIn]);
    // Dodano komentarz eslint-disable-line, ponieważ eslint może sugerować dodanie setNewsData, ale nie chcemy, aby efekt się powtórzył przy zmianie newsData

    const [newsForm, setNewsForm] = useState({ title: '', category: NewsCategory.EVENT, description: '', content: '' });

    const handleNewsSubmit = () => {
        const newNews: News = {
            id: editingNews ? editingNews.id : generateUUID() as UUID,
            title: newsForm.title,
            category: newsForm.category as NewsCategory,
            description: newsForm.description,
            content: newsForm.content,
            modificationDate: new Date()
        };
        let controller = new ApiController()
        if (editingNews) {
            controller.UpdateNews(newNews);
            setNewsData(prev => prev.map(item => item.id === editingNews.id ? newNews : item));
        } else {
            controller.AddNews(newNews);
            setNewsData(prev => [newNews, ...prev]);
        }
        setShowNewsModal(false);
        setEditingNews(null);
        setNewsForm({ title: '', category: NewsCategory.EVENT, description: '', content: '' });
        alert('Aktualność została dodana do bazy');
    };

    const handleEditNews = (news: News) => { // Akceptuje zaimportowany typ News
        setEditingNews(news);
        setNewsForm({
            title: news.title,
            category: news.category,
            description: news.description,
            content: news.content
        });
        setShowNewsModal(true);
    };

    const handleDeleteNews = (id: string) => {
        //TODO: dodaj modal boxa z potwierdzeniem akcji
        let controller = new ApiController()
        controller.DeleteNews(id)
        setNewsData(prev => prev.filter(item => item.id !== id));
        alert('Aktualność została usunięta z bazy danych');
    };


    const getBadgeStyle = (category: string) => {
        const badges: Record<string, React.CSSProperties> = {
            'EVENT': { background: 'rgba(59, 130, 246, 0.2)', color: '#60a5fa', border: '1px solid rgba(59, 130, 246, 0.3)' },
            'CONFERENCE': { background: 'rgba(16, 185, 129, 0.2)', color: '#34d399', border: '1px solid rgba(16, 185, 129, 0.3)' },
            'UPDATE': { background: 'rgba(236, 72, 153, 0.2)', color: '#f472b6', border: '1px solid rgba(236, 72, 153, 0.3)' },
            'NEW_VERSION': { background: 'rgba(239, 68, 68, 0.2)', color: '#f87171', border: '1px solid rgba(239, 68, 68, 0.3)' },
            'TECH': { background: 'rgba(139, 92, 246, 0.2)', color: '#a78bfa', border: '1px solid rgba(139, 92, 246, 0.3)' },
            'COOP': { background: 'rgba(16, 185, 129, 0.2)', color: '#34d399', border: '1px solid rgba(16, 185, 129, 0.3)' },
            'SUPPORT': { background: 'rgba(239, 68, 68, 0.2)', color: '#f87171', border: '1px solid rgba(239, 68, 68, 0.3)' },
            'QUESTION': { background: 'rgba(59, 130, 246, 0.2)', color: '#60a5fa', border: '1px solid rgba(59, 130, 246, 0.3)' }
        };
        return badges[category] || { background: 'rgba(100, 100, 100, 0.2)', color: '#cccccc', border: '1px solid rgba(100, 100, 100, 0.3)' };
    };

    const baseStyles = {
        body: {
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            background: '#000000',
            minHeight: '100vh',
            color: '#ffffff',
            margin: 0,
            padding: 0,
        } as React.CSSProperties,

        loginContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            padding: '20px',
            position: 'relative',
            zIndex: 10,
        } as React.CSSProperties,

        loginBox: {
            background: 'rgba(20, 20, 20, 0.95)',
            backdropFilter: 'blur(20px)',
            borderRadius: '20px',
            padding: '40px',
            width: '100%',
            maxWidth: '400px',
            boxShadow: '0 20px 40px rgba(255, 140, 0, 0.1)',
            border: '1px solid rgba(255, 140, 0, 0.2)',
            position: 'relative',
        } as React.CSSProperties,

        sidebar: {
            position: 'fixed',
            left: 0,
            top: 0,
            width: '280px',
            height: '100vh',
            background: 'rgba(15, 15, 15, 0.95)',
            backdropFilter: 'blur(20px)',
            padding: '20px 0',
            overflowY: 'auto',
            zIndex: 1000,
            borderRight: '1px solid rgba(255, 140, 0, 0.2)',
        } as React.CSSProperties,

        mainContent: {
            marginLeft: '280px',
            padding: '20px',
        } as React.CSSProperties,

        topBar: {
            background: 'rgba(20, 20, 20, 0.95)',
            backdropFilter: 'blur(20px)',
            padding: '15px 30px',
            borderRadius: '15px',
            boxShadow: '0 2px 10px rgba(255, 140, 0, 0.1)',
            marginBottom: '20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            border: '1px solid rgba(255, 140, 0, 0.2)',
        } as React.CSSProperties,

        contentSection: {
            background: 'rgba(20, 20, 20, 0.95)',
            backdropFilter: 'blur(20px)',
            borderRadius: '15px',
            padding: '30px',
            boxShadow: '0 2px 10px rgba(255, 140, 0, 0.1)',
            border: '1px solid rgba(255, 140, 0, 0.2)',
        } as React.CSSProperties,

        btn: {
            padding: '10px 20px',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
        } as React.CSSProperties,

        btnPrimary: {
            background: 'linear-gradient(135deg, #ff8c00 0%, #ff6b35 100%)',
            color: 'white',
        } as React.CSSProperties,

        modal: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.8)',
            zIndex: 2000,
            backdropFilter: 'blur(5px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        } as React.CSSProperties,

        modalContent: {
            background: 'rgba(20, 20, 20, 0.95)',
            backdropFilter: 'blur(20px)',
            borderRadius: '15px',
            padding: '30px',
            width: '90%',
            maxWidth: '600px',
            maxHeight: '80vh',
            overflowY: 'auto',
            border: '1px solid rgba(255, 140, 0, 0.3)',
        } as React.CSSProperties,
    };

    if (!isLoggedIn) {
        return (
            <section id="admin-panel" style={baseStyles.body}>
                <Particles />
                <div style={baseStyles.loginContainer}>
                    <div style={baseStyles.loginBox}>
                        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                            <h1 style={{ color: '#ffffff', fontSize: '28px', marginBottom: '10px', fontWeight: '700' }}>
                                <span style={{ color: '#ff8c00', fontWeight: '800' }}>Cage</span>EEG Admin
                            </h1>
                            <p style={{ color: '#cccccc', fontSize: '14px' }}>
                                Narzędzia i interfejsy encefalograficzne do badań i rozrywki
                            </p>
                        </div>
                        <div>
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#ffffff' }}>
                                    Nazwa użytkownika
                                </label>
                                <input
                                    type="text"
                                    placeholder="admin"
                                    value={loginForm.username}
                                    onChange={(e) => setLoginForm(prev => ({ ...prev, username: e.target.value }))}
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '12px 16px',
                                        border: '2px solid rgba(255, 140, 0, 0.3)',
                                        borderRadius: '10px',
                                        fontSize: '16px',
                                        background: 'rgba(30, 30, 30, 0.8)',
                                        color: '#ffffff',
                                        boxSizing: 'border-box',
                                    }}
                                />
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#ffffff' }}>
                                    Hasło
                                </label>
                                <input
                                    type="password"
                                    placeholder="admin"
                                    value={loginForm.password}
                                    onChange={(e) => setLoginForm(prev => ({ ...prev, password: e.target.value }))}
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '12px 16px',
                                        border: '2px solid rgba(255, 140, 0, 0.3)',
                                        borderRadius: '10px',
                                        fontSize: '16px',
                                        background: 'rgba(30, 30, 30, 0.8)',
                                        color: '#ffffff',
                                        boxSizing: 'border-box',
                                    }}
                                />
                            </div>
                            <button
                                onClick={handleLogin}
                                style={{
                                    width: '100%',
                                    padding: '14px',
                                    background: 'linear-gradient(135deg, #ff8c00 0%, #ff6b35 100%)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '10px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                }}
                            >
                                Uwolnij potencjał myśli
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    const renderDashboard = () => (
        <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '30px' }}>
                {[
                    { title: newsData.length, subtitle: 'Aktualności' }, // Używamy ilości danych ze stanu
                    { title: messagesData.length, subtitle: 'Wiadomości' }, // Używamy ilości danych ze stanu
                    { title: 8, subtitle: 'Użytkownicy' }, // Nadal mock
                    { title: 3, subtitle: 'Oczekujące' } // Nadal mock
                ].map((stat, index) => (
                    <div key={index} style={{
                        background: 'linear-gradient(135deg, rgba(255, 140, 0, 0.1) 0%, rgba(255, 107, 53, 0.1) 100%)',
                        border: '1px solid rgba(255, 140, 0, 0.3)',
                        color: 'white',
                        padding: '25px',
                        borderRadius: '15px',
                        textAlign: 'center',
                        backdropFilter: 'blur(10px)',
                    }}>
                        <h3 style={{ fontSize: '36px', marginBottom: '10px', color: '#ff8c00' }}>{stat.title}</h3>
                        <p style={{ opacity: 0.9, fontSize: '14px', color: '#cccccc' }}>{stat.subtitle}</p>
                    </div>
                ))}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', paddingBottom: '15px', borderBottom: '2px solid rgba(255, 140, 0, 0.3)' }}>
                <h2 style={{ color: '#ffffff', fontSize: '24px' }}>Ostatnie działania</h2>
            </div>
            <p style={{ color: '#cccccc' }}>Tutaj będą wyświetlane najnowsze aktywności w systemie...</p>
        </div>
    );

    const renderNews = () => (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', paddingBottom: '15px', borderBottom: '2px solid rgba(255, 140, 0, 0.3)' }}>
                <h2 style={{ color: '#ffffff', fontSize: '24px' }}>Zarządzanie Aktualnościami</h2>
                <button
                    style={{ ...baseStyles.btn, ...baseStyles.btnPrimary }}
                    onClick={() => {
                        setEditingNews(null); // Ustawia, że dodajemy nowy news
                        setNewsForm({ title: '', category: NewsCategory.EVENT, description: '', content: '' }); // Czyści formularz
                        setShowNewsModal(true);
                    }}
                >
                    <Plus size={16} /> Dodaj Aktualność
                </button>
            </div>
            {/* Wskazanie ładowania danych */}
            {loadingNews ? (
                <div style={{ textAlign: 'center', padding: '50px', color: '#cccccc' }}>Ładowanie aktualności...</div>
            ) : newsData.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '50px', color: '#cccccc' }}>Brak dostępnych aktualności.</div>
            ) : newsData[0].title === "Loading data error" ? (
                <div style={{ textAlign: 'center', padding: '50px', color: '#ff4444' }}>Loading data error</div>
            ) : (
                // Tabela wyświetlana tylko gdy dane są załadowane i nie są puste
                <table style={{ width: '100%', borderCollapse: 'collapse', background: 'rgba(30, 30, 30, 0.5)', borderRadius: '10px', overflow: 'hidden' }}>
                    <thead>
                    <tr>
                        <th style={{ padding: '15px', textAlign: 'left', background: 'rgba(255, 140, 0, 0.1)', fontWeight: '600', color: '#ffffff' }}>Tytuł</th>
                        <th style={{ padding: '15px', textAlign: 'left', background: 'rgba(255, 140, 0, 0.1)', fontWeight: '600', color: '#ffffff' }}>Kategoria</th>
                        <th style={{ padding: '15px', textAlign: 'left', background: 'rgba(255, 140, 0, 0.1)', fontWeight: '600', color: '#ffffff' }}>Data modyfikacji</th>
                        <th style={{ padding: '15px', textAlign: 'left', background: 'rgba(255, 140, 0, 0.1)', fontWeight: '600', color: '#ffffff' }}>Akcje</th>
                    </tr>
                    </thead>
                    <tbody>
                    {newsData.map((news) => ( // Używamy zaimportowanego typu News
                        <tr key={news.id} style={{ borderBottom: '1px solid rgba(255, 140, 0, 0.1)' }}>
                            <td style={{ padding: '15px', color: '#cccccc' }}>{news.title}</td>
                            <td style={{ padding: '15px' }}>
                                        <span style={{
                                            padding: '4px 12px',
                                            borderRadius: '20px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            textTransform: 'uppercase',
                                            ...getBadgeStyle(news.category.toString())
                                        }}>
                                            {news.category}
                                        </span>
                            </td>
                            {/* Formatowanie daty - upewnij się, że news.modificationDate jest obiektem Date */}
                            <td style={{ padding: '15px', color: '#cccccc' }}>
                                {news.modificationDate instanceof Date
                                    ? news.modificationDate.toLocaleDateString('pl-PL', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })
                                    : new Date(news.modificationDate).toLocaleDateString('pl-PL', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })
                                }
                            </td>
                            <td style={{ padding: '15px', display: 'flex', gap: '10px' }}>
                                <button
                                    style={{ ...baseStyles.btn, background: 'rgba(100, 100, 100, 0.3)', color: '#cccccc', border: '1px solid rgba(255, 140, 0, 0.2)' }}
                                    onClick={() => handleEditNews(news)} // Przekazuje News
                                >
                                    <Edit size={16} />
                                </button>
                                <button
                                    style={{ ...baseStyles.btn, background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', color: 'white' }}
                                    onClick={() => handleDeleteNews(news.id)} // Przekazuje ID
                                >
                                    <Trash2 size={16} />
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
        </div>
    );

    const renderMessages = () => (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', paddingBottom: '15px', borderBottom: '2px solid rgba(255, 140, 0, 0.3)' }}>
                <h2 style={{ color: '#ffffff', fontSize: '24px' }}>Wiadomości od użytkowników</h2>
            </div>
            {messagesData.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '50px', color: '#cccccc' }}>Brak nowych wiadomości.</div>
            ) : messagesData[0].fullname === "Loading data error" ? (
                <div style={{ textAlign: 'center', padding: '50px', color: '#ff4444' }}>Loading data error</div>
            ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', background: 'rgba(30, 30, 30, 0.5)', borderRadius: '10px', overflow: 'hidden' }}>
                    <thead>
                    <tr>
                        <th style={{ padding: '15px', textAlign: 'left', background: 'rgba(255, 140, 0, 0.1)', fontWeight: '600', color: '#ffffff' }}>Imię i nazwisko</th>
                        <th style={{ padding: '15px', textAlign: 'left', background: 'rgba(255, 140, 0, 0.1)', fontWeight: '600', color: '#ffffff' }}>Email</th>
                        <th style={{ padding: '15px', textAlign: 'left', background: 'rgba(255, 140, 0, 0.1)', fontWeight: '600', color: '#ffffff' }}>Typ</th>
                        <th style={{ padding: '15px', textAlign: 'left', background: 'rgba(255, 140, 0, 0.1)', fontWeight: '600', color: '#ffffff' }}>Treść</th>
                        {/* Usuwamy kolumnę Akcje */}
                    </tr>
                    </thead>
                    <tbody>
                    {messagesData.map((message) => (
                        <tr key={message.id} style={{ borderBottom: '1px solid rgba(255, 140, 0, 0.1)' }}>
                            <td style={{ padding: '15px', color: '#cccccc' }}>{message.fullname}</td>
                            <td style={{ padding: '15px', color: '#cccccc' }}>{message.email}</td>
                            <td style={{ padding: '15px' }}>
                                <span style={{
                                    padding: '4px 12px',
                                    borderRadius: '20px',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    ...getBadgeStyle(message.topic)
                                }}>
                                    {message.topic}
                                </span>
                            </td>
                            <td style={{ padding: '15px', color: '#cccccc' }}>{message.content}</td>
                            {/* Usuwamy przyciski Akcje */}
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
        </div>
    );

    const renderUsers = () => (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', paddingBottom: '15px', borderBottom: '2px solid rgba(255, 140, 0, 0.3)' }}>
                <h2 style={{ color: '#ffffff', fontSize: '24px' }}>Zarządzanie Użytkownikami</h2>
                <button
                    style={{ ...baseStyles.btn, ...baseStyles.btnPrimary }}
                    onClick={() => setShowUserModal(true)}
                >
                    <UserPlus size={16} /> Dodaj Użytkownika
                </button>
            </div>
            <div style={{ textAlign: 'center', padding: '50px', color: '#888888' }}>
                <Construction size={64} style={{ color: '#ff8c00', marginBottom: '20px' }} />
                <h3 style={{ color: '#ffffff', marginBottom: '10px' }}>Sekcja w budowie</h3>
                <p>Zarządzanie użytkownikami będzie dostępne po integracji z Keycloak</p>
            </div>
        </div>
    );

    return (
        <section id="admin-panel" style={baseStyles.body}>
            <Particles />

            {/* Sidebar */}
            <nav style={baseStyles.sidebar}>
                <div style={{ padding: '0 20px 30px', borderBottom: '1px solid rgba(255, 140, 0, 0.3)', marginBottom: '20px' }}>
                    <h2 style={{ color: 'white', fontSize: '20px', marginBottom: '5px' }}>
                        <span style={{ color: '#ff8c00', fontWeight: '800' }}>Cage</span>EEG Admin
                    </h2>
                    <p style={{ color: '#cccccc', fontSize: '12px' }}>System Zarządzania</p>
                </div>
                <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                    {[
                        { id: 'dashboard', icon: Home, label: 'Dashboard' },
                        { id: 'news', icon: Newspaper, label: 'Aktualności' },
                        { id: 'messages', icon: Mail, label: 'Wiadomości' },
                        { id: 'users', icon: Users, label: 'Użytkownicy' }
                    ].map(({ id, icon: Icon, label }) => (
                        <li key={id} style={{ marginBottom: '5px' }}>
                            <a
                                href="#"
                                onClick={(e) => { e.preventDefault(); setActiveSection(id); }}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '15px 20px',
                                    color: activeSection === id ? 'white' : '#cccccc',
                                    textDecoration: 'none',
                                    borderLeft: `3px solid ${activeSection === id ? '#ff8c00' : 'transparent'}`,
                                    background: activeSection === id ? 'rgba(255, 140, 0, 0.1)' : 'transparent',
                                }}
                            >
                                <Icon size={20} style={{ marginRight: '12px' }} />
                                {label}
                            </a>
                        </li>
                    ))}
                </ul>
            </nav>

            {/* Main Content */}
            <main style={baseStyles.mainContent}>
                {/* Top Bar */}
                <div style={baseStyles.topBar}>
                    <h1 style={{ color: '#ffffff', fontSize: '24px' }}>
                        {activeSection === 'dashboard' && 'Dashboard'}
                        {activeSection === 'news' && 'Aktualności'}
                        {activeSection === 'messages' && 'Wiadomości'}
                        {activeSection === 'users' && 'Użytkownicy'}
                    </h1>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', color: '#cccccc' }}>
                        <span>Witaj, Admin!</span>
                        <button
                            style={{
                                padding: '8px 16px',
                                background: 'linear-gradient(135deg, #ff4444 0%, #cc3333 100%)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '14px'
                            }}
                            onClick={handleLogout}
                        >
                            Wyloguj
                        </button>
                    </div>
                </div>

                {/* Content Section */}
                <div style={baseStyles.contentSection}>
                    {activeSection === 'dashboard' && renderDashboard()}
                    {activeSection === 'news' && renderNews()}
                    {activeSection === 'messages' && renderMessages()}
                    {activeSection === 'users' && renderUsers()}
                </div>
            </main>

            {/* News Modal */}
            {showNewsModal && (
                <div style={baseStyles.modal} onClick={(e) => { if (e.target === e.currentTarget) setShowNewsModal(false); }}>
                    <div style={baseStyles.modalContent}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', paddingBottom: '15px', borderBottom: '1px solid rgba(255, 140, 0, 0.3)' }}>
                            <h3 style={{ color: '#ffffff', fontSize: '20px' }}>
                                {editingNews ? 'Edytuj Aktualność' : 'Dodaj Aktualność'}
                            </h3>
                            <button
                                style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#cccccc' }}
                                onClick={() => setShowNewsModal(false)}
                            >
                                <X size={24} />
                            </button>
                        </div>
                        <div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#ffffff' }}>Tytuł</label>
                                    <input
                                        type="text"
                                        value={newsForm.title}
                                        onChange={(e) => setNewsForm(prev => ({ ...prev, title: e.target.value }))}
                                        required
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '2px solid rgba(255, 140, 0, 0.3)',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            background: 'rgba(30, 30, 30, 0.8)',
                                            color: '#ffffff',
                                            boxSizing: 'border-box',
                                        }}
                                    />
                                </div>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#ffffff' }}>Kategoria</label>
                                    <select
                                        value={newsForm.category}
                                        onChange={(e) => setNewsForm(prev => ({ ...prev, category: e.target.value as NewsCategory }))}
                                        required
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '2px solid rgba(255, 140, 0, 0.3)',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            background: 'rgba(30, 30, 30, 0.8)',
                                            color: '#ffffff',
                                            boxSizing: 'border-box',
                                        }}
                                    >
                                        <option >Wybierz kategorię</option>
                                        <option value={NewsCategory.EVENT}>EVENT</option>
                                        <option value={NewsCategory.CONFERENCE}>CONFERENCE</option>
                                        <option value={NewsCategory.UPDATE}>UPDATE</option>
                                        <option value={NewsCategory.NEW_VERSION}>NEW VERSION</option> {/* Zmiana nazwy dla czytelności */}
                                        {/* Dodaj inne kategorie, jeśli są potrzebne */}
                                    </select>
                                </div>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#ffffff' }}>Opis</label>
                                <textarea
                                    rows={3}
                                    value={newsForm.description}
                                    onChange={(e) => setNewsForm(prev => ({ ...prev, description: e.target.value }))}
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        border: '2px solid rgba(255, 140, 0, 0.3)',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        background: 'rgba(30, 30, 30, 0.8)',
                                        color: '#ffffff',
                                        resize: 'vertical',
                                        boxSizing: 'border-box',
                                    }}
                                />
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#ffffff' }}>Treść</label>
                                <textarea
                                    rows={6}
                                    value={newsForm.content}
                                    onChange={(e) => setNewsForm(prev => ({ ...prev, content: e.target.value }))}
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        border: '2px solid rgba(255, 140, 0, 0.3)',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        background: 'rgba(30, 30, 30, 0.8)',
                                        color: '#ffffff',
                                        resize: 'vertical',
                                        boxSizing: 'border-box',
                                    }}
                                />
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button
                                    type="button"
                                    style={{ ...baseStyles.btn, background: 'rgba(100, 100, 100, 0.3)', color: '#cccccc', border: '1px solid rgba(255, 140, 0, 0.2)' }}
                                    onClick={() => setShowNewsModal(false)}
                                >
                                    Anuluj
                                </button>
                                <button
                                    onClick={handleNewsSubmit}
                                    style={{ ...baseStyles.btn, ...baseStyles.btnPrimary }}
                                >
                                    Zapisz
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* User Modal */}
            {showUserModal && (
                <div style={baseStyles.modal} onClick={(e) => { if (e.target === e.currentTarget) setShowUserModal(false); }}>
                    <div style={baseStyles.modalContent}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', paddingBottom: '15px', borderBottom: '1px solid rgba(255, 140, 0, 0.3)' }}>
                            <h3 style={{ color: '#ffffff', fontSize: '20px' }}>Dodaj Użytkownika</h3>
                            <button
                                style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#cccccc' }}
                                onClick={() => setShowUserModal(false)}
                            >
                                <X size={24} />
                            </button>
                        </div>
                        <div style={{ textAlign: 'center', padding: '50px', color: '#cccccc' }}>
                            <p>Funkcjonalność będzie dostępna po integracji z Keycloak</p>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default AdminPanelComponent;
